import { render, staticRenderFns } from "./HKLUploadButton.vue?vue&type=template&id=4f6e54cf&"
import script from "./HKLUploadButton.vue?vue&type=script&lang=js&"
export * from "./HKLUploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6e54cf')) {
      api.createRecord('4f6e54cf', component.options)
    } else {
      api.reload('4f6e54cf', component.options)
    }
    module.hot.accept("./HKLUploadButton.vue?vue&type=template&id=4f6e54cf&", function () {
      api.rerender('4f6e54cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Button/HKLUploadButton.vue"
export default component.exports